<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <path
        fill="inherit"
        stroke="none"
        d="M6 17v-2h9.6l7-7h-3.93V6H26v7.33h-2V9.4L16.4 17zm12.67 9v-2h3.93l-4.7-4.66 1.44-1.45L24 22.6v-3.92h2V26z"
      />
    </svg>
  </span>
</template>
